<div [formGroup]="frmGroup" class = "dhl-checkbox-container-v2"[class.disabled]="configData.disabled">
    <input type = "checkbox" #checkbox [formControlName]="configData.name" [required]="configData.required" (click)="handleClick()"/>
    <label class = "dhl-label-checkbox-v2">{{configData.label}}</label>
</div>
<br>
<div class="form-field-error" [ngClass]="{'hide-error': !frmGroup.get(configData.name).errors}">
    <span class="error-icon">
        <img class="dhl-input-error-icon" src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
    </span>
    <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
        <span *ngIf="frmGroup.get(configData.name).errors?.groupValidationError">
            {{$safeNavigationMigration(frmGroup.get(configData.name).errors?.groupValidationError) | translate}}
        </span>
    </span>
</div>
